var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideBarActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.882812,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#111111"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.882812,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#55BD5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5755 5.10938L5.66276 10.0718L3.42969 7.81613",
    stroke: "white",
    strokeWidth: 2.16076,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarActive);
export default __webpack_public_path__ + "static/media/SideBarActive.e916eb049a972203c2cb9ed07640cc97.svg";
export { ForwardRef as ReactComponent };